import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MenuModule } from 'primeng/menu';
import { PanelMenuModule } from 'primeng/panelmenu';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { TabMenuModule } from 'primeng/tabmenu';
import { InputTextComponent } from './primeNg-components/input-text/input-text.component';
import { InputTextModule } from 'primeng/inputtext';
import { DropdownModule } from 'primeng/dropdown';
import { DialogModule } from 'primeng/dialog';
import { StepsModule } from 'primeng/steps';
import { SidebarModule } from 'primeng/sidebar';
import { FileUploadModule } from 'primeng/fileupload';
import { MenubarModule } from 'primeng/menubar';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { TableModule } from 'primeng/table';
import { NgProgressModule } from 'ngx-progressbar';
import { PinCodeComponent } from './pin-code/pin-code.component';
import { TagModule } from 'primeng/tag';
import { TabViewModule } from 'primeng/tabview';
import { DividerModule } from 'primeng/divider';

@NgModule({
  declarations: [
    InputTextComponent,
    PinCodeComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    MenuModule,
    MenubarModule,
    PanelMenuModule,
    FileUploadModule,
    TableModule,
    ButtonModule,
    InputTextModule,
    DropdownModule,
    ReactiveFormsModule,
    DialogModule,
    StepsModule,
    SidebarModule,
    TabMenuModule,
    ProgressSpinnerModule,
    NgProgressModule,
    TagModule,
    TabViewModule,
    DividerModule
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    InputTextModule,
    FileUploadModule,
    InputTextComponent,
    DropdownModule,
    DialogModule,
    ButtonModule,
    StepsModule,
    SidebarModule,
    TabMenuModule,
    MenubarModule,
    PinCodeComponent,
    TagModule,
    TabViewModule,
    DividerModule
  ],
  providers: [],
})
export class SharedModule { }

